import ApiService from '@/helpers/api.service';
import ApiService2 from '@/helpers/api.service.ext';

const API = new ApiService();
const API2 = new ApiService2();

// Endpoints

export const state = {
    regionList: [],
    provinceList: [],
    cityList: [],
    barangayList: [],
    businessTypesList: [],
    businessList: [],
    businessPageInfo: {
        total: 0
    },
    businessDetails: {},
    businessSocialMedias: "",
    businessCustomerList: [],
    businessCustomerPageInfo: {
        total: 0
    },
    businessProductList: [],
    businessProductPageInfo: {
        total: 0
    },
    subscriberList: [],
    subscriberPageInfo: {
        total: 0
    },
    subscriberDetails: {},
    subscriberIDs:[],
    userWalletsList: [],
    updateUserWalletStatus: {},
    reasonLogsList: [],
    reasonLogsPageInfo: {
        total: 0
    },
    errors: null,
    businessQr:null,
    secQueHistory: []
}

export const mutations = {
    UPDATE_BUSINESS_TYPE_LIST(state, types){
        state.businessTypesList = types;
    },
    UPDATE_REGION_LIST(state, region){
        state.regionList = region;
    },
    UPDATE_PROVINCE_LIST(state, province){
        state.provinceList = province;
    },
    UPDATE_CITY_LIST(state, city){
        state.cityList = city;
    },
    UPDATE_BARANGAY_LIST(state, barangay){
        state.barangayList = barangay;
    },
    UPDATE_BUSINESS_LIST(state, business){
        state.businessList = business;
    },
    UPDATE_BUSINESS_PAGE_INFO(state, total){
        state.businessPageInfo.total = total;
    },
    UPDATE_BUSINESS_COSTUMER_LIST(state, list){
        state.businessCustomerList = list;
    },
    UPDATE_BUSINESS_COSTUMER_PAGE_INFO(state, total){
        state.businessCustomerPageInfo.total = total;
    },
    UPDATE_BUSINESS_PRODUCT_LIST(state, list){
        state.businessProductList = list;
    },
    UPDATE_BUSINESS_PRODUCT_PAGE_INFO(state, total){
        state.businessProductPageInfo.total = total;
    },
    UPDATE_BUSINESS_INFO(state, info){
        state.businessDetails = info;
        if(info.socialMediasLink) state.businessSocialMedias = JSON.parse(info.socialMediasLink)
    },
    UPDATE_STORE_CATEGORY(state, info){
        state.businessDetails["storeCategory"] = info;
    },
    UPDATE_SUBSCRIBER_LIST(state, subscriber){
        let tempList = subscriber;

        state.subscriberList = tempList.map(data => {
            let accountType = data.kyc_acct_type
            switch (accountType) {
                case 'FullyVerified':
                    data.kyc_acct_type = "Fully Verified"
                    break;
                case 'FailedKYC':
                    data.kyc_acct_type = "Failed KYC"
                    break;
                case 'NoKYC':
                    data.kyc_acct_type = "Don't Have KYC"
                    break;
                default:
                    break;
            }

            let accountStatus = data.kyc_acct_status
            switch (accountStatus) {
                case 'PendingVerification':
                    data.kyc_acct_status = "Pending Verification"
                    break;
                case 'FailedVerification':
                    data.kyc_acct_status = "Failed Verification"
                    break;
                default:
                    break;
            }

            return data
        });
    },
    UPDATE_SUBSCRIBER_PAGE_INFO(state, total){
        state.subscriberPageInfo.total = total;
    },
    UPDATE_SUBSCRIBER_INFO(state, info){
        state.subscriberDetails = info;
        if(info.socialMediasLink) state.businessSocialMedias = JSON.parse(info.socialMediasLink)
        if(info.kyc_details) state.subscriberIDs = [info.kyc_details.id_card,info.kyc_details.selfie]
        if(info.kyc_details){
            try {
                if(info.kyc_details.kyc_history){
                    for(let data of info.kyc_details.kyc_history){
                        if(data.action == "upload" || data.action == "re-upload"){
                            state.subscriberIDs.push(data.id_card, data.selfie)
                        }
                    }
                }   
            } catch (error) {
                console.log(">> KYC PUSH IMAGE err:", error)
            }
        }
    },
    UPDATE_USER_WALLETS_LIST(state, data){
        state.userWalletsList = data;
    },
    UPDATE_USER_WALLETS_STATUS(state, data){
        state.updateUserWalletStatus = data;
    },
    UPDATE_REASON_LOGS(state, logs){
        state.reasonLogsList = logs;
    },
    UPDATE_REASON_LOGS_PAGE_INFO(state, total){
        state.reasonLogsPageInfo.total = total;
    },
    SET_PROD_ERRORS(state, errors){
        state.errors = errors;
    },
    UPDATE_BUSINESS_QR_INFO(state, base64img){
        state.businessQr = base64img;
    },
    UPDATE_SEC_QUE_HISTORY(state, secQueHistory){
        state.secQueHistory = secQueHistory
    }
}

export const actions = {
    getBusinessTypesList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/types`, params)
            .then(({ data }) => {
              context.commit('UPDATE_BUSINESS_TYPE_LIST', data.message.rows);
              resolve();
            })
            .catch(() => {
              context.commit('UPDATE_BUSINESS_TYPE_LIST', []);
              reject();
            });
        });
    },
    getRegionList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/regions`, params)
            .then(({ data }) => {
              context.commit('UPDATE_REGION_LIST', data.message.rows);
              resolve();
            })
            .catch(() => {
              context.commit('UPDATE_REGION_LIST', []);
              reject();
            });
        });
    },
    getProvinceList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/provinces`, params)
            .then(({ data }) => {
              context.commit('UPDATE_PROVINCE_LIST', data.message.rows);
              resolve();
            })
            .catch(() => {
              context.commit('UPDATE_PROVINCE_LIST', []);
              reject();
            });
        });
    },
    getCityList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/cities`, params)
            .then(({ data }) => {
              context.commit('UPDATE_CITY_LIST', data.message.rows);
              resolve();
            })
            .catch(() => {
              context.commit('UPDATE_CITY_LIST', []);
              reject();
            });
        });
    },
    getBarangayList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/barangays`, params)
            .then(({ data }) => {
              context.commit('UPDATE_BARANGAY_LIST', data.message.rows);
              resolve();
            })
            .catch(() => {
              context.commit('UPDATE_BARANGAY_LIST', []);
              reject();
            });
        });
    },
    getBusinessList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/list`, params)
            .then(({ data }) => {
              context.commit('UPDATE_BUSINESS_LIST', data.message.rows);
              context.commit('UPDATE_BUSINESS_PAGE_INFO', data.message.pageInfo.total);
              resolve();
            })
            .catch(() => {
            //   context.commit('SET_PROD_ERRORS', response.data.errors);
              context.commit('UPDATE_BUSINESS_LIST', []);
              context.commit('UPDATE_BUSINESS_PAGE_INFO', 0);
              reject();
            });
        });
    },
    getBusinessDetails(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/business/info`, params)
            .then(({ data }) => {
                context.commit('UPDATE_BUSINESS_INFO', data.message[0]);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });        
    },
    getBusinessCustomersList(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/business/customer`, params)
            .then(({ data }) => {
                context.commit('UPDATE_BUSINESS_COSTUMER_LIST', data.message.rows);
                context.commit('UPDATE_BUSINESS_COSTUMER_PAGE_INFO', data.message.pageInfo.total);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });        
    },
    getBusinessProductsList(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/business/product`, params)
            .then(({ data }) => {
                context.commit('UPDATE_BUSINESS_PRODUCT_LIST', data.message.rows);
                context.commit('UPDATE_BUSINESS_PRODUCT_PAGE_INFO', data.message.pageInfo.total);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });        
    },
    updateWalletStatus(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/business/update-wallet-status`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve({ status: 'ok' })
                } else {
                    reject(data)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject(response);
            });
        });        
    },
    getReasonLogsList(context, params) {
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/business/get-reason-logs`, params)
            .then(({ data }) => {
                context.commit('UPDATE_REASON_LOGS', data.message.rows);
                context.commit('UPDATE_REASON_LOGS_PAGE_INFO', data.message.pageInfo.total);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });        
    },
    getUserWalletsList(context, params){
        return new Promise((resolve, reject) => {
          API.post(`/subscriber/business/get-user-wallets-list`, params)
            .then(({ data }) => {
            //   context.commit('UPDATE_USER_WALLETS_LIST', data.message.rows);
            //   resolve();

                if (data.status === "ok") {
                    resolve(data.message.rows)
                } else {
                    reject(data.message)
                }
                context.commit('UPDATE_USER_WALLETS_LIST', data.message.rows);
            })
            .catch(() => {
              context.commit('UPDATE_USER_WALLETS_LIST', []);
              reject();
            });
        });
    },
    updateUserWalletStatus(context, params){
        return new Promise((resolve, reject) => {
          API2.post(`/merchant/update-user-wallet-status`, params)
            .then(({ data }) => {
                if (data.status === "ok") {
                    resolve(data)
                } else {
                    reject(data.message)
                }
                context.commit('UPDATE_USER_WALLETS_STATUS', data.message);
            })
            .catch(({ response }) => {
              context.commit('UPDATE_USER_WALLETS_STATUS', response.message);
              reject();
            });
        });
    },
    sendSecQue(context, params){
        console.log(context);
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/send-security-question`, params)
                .then(({ data }) => {
                    if (data.status === "ok") {
                        resolve(data)
                    } else {
                        reject(data.message)
                    }
                })
                .catch(({ response }) => {
                    console.log(response)
                    reject();
                });
        });
    },
    fetchSecQueHistory(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/security-question-history`, params)
                .then(({ data }) => {
                    if (data.status === "ok") {
                        resolve(data)
                    } else {
                        reject(data.message)
                    }
                    context.commit('UPDATE_SEC_QUE_HISTORY', data.message.row);
                })
                .catch(({ response }) => {
                    console.log(response);
                    context.commit('UPDATE_SEC_QUE_HISTORY', []);
                    reject();
                });
          });
    },
    // End of Business Action
    
    getSubscriberList(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/profile/list`, params)
            .then(({ data }) => {
                context.commit('UPDATE_SUBSCRIBER_LIST', data.message.rows);
                context.commit('UPDATE_SUBSCRIBER_PAGE_INFO', data.message.pageInfo.total);
                resolve();
            })
            .catch(({ response }) => {
                console.log(response);
                //context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    getSubscriberDetails(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/profile/user`, params)
            .then(({ data }) => {
                context.commit('UPDATE_SUBSCRIBER_INFO', data.message);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    actionKYC(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/profile/kyc`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject()
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    updateVerifiedKYC(context, params){
        return new Promise((resolve, reject) => {
            API.post(`/subscriber/profile/update-kyc`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject()
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    // End of Subscribers Action
    actionBusinessInfos(context, params) {
        // await this.actionBusinessInfos({
        //     action: "list",
        //     body: this.searchValue
        // })
      return new Promise((resolve, reject) => {
        API.post(`/subscriber/business/${params.action}`, params.body)
          .then(({ data }) => {
            if (data.status === "ok") {
              resolve(data)
            } else {
              reject(data.message)
            }
          })
          .catch(({ response }) => {
            context.commit('SET_ERROR', response.data.errors);
            reject();
          });
      });
    },
    updateMdrWhitelist(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/update-kankolek-mdr-settings`, params)
            .then(({ data }) => {
                if(data.status === "ok") {
                    resolve()
                } else {
                    reject(data.message)
                }
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject(response.data.errors);
            });
        });
    },
    getSubscriberListv2(context, params){
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/list`, params)
            .then(({ data }) => {
                context.commit('UPDATE_SUBSCRIBER_LIST', data.message.rows);
                // Compute if there are more pages: total remaining after current page
                const total = data.message.pageInfo.total;
                const currentOffset = (params.page || 1) * (params.rows || 10);
                context.commit('UPDATE_SUBSCRIBER_PAGE_INFO', total > currentOffset ? 1 : 0);
                resolve();
            })
            .catch(({ response }) => {
                console.log(response);
                //context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });
    },
    getBusinessDetailsv2(context, params) {
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/info`, params)
            .then(({ data }) => {
                context.commit('UPDATE_BUSINESS_INFO', data.message[0]);
                resolve();
            })
            .catch(({ response }) => {
                context.commit('SET_PROD_ERRORS', response.data.errors);
                reject();
            });
        });        
    },
    getKankolekMDR() {
        return new Promise((resolve, reject) => {
            API2.get(`/merchant/kankolek-mdr-options`)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response.data.errors);
            });
        });        
    },
    getKankolekMdrLogs(context, params) {
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/get-kankolek-mdr-logs`, params)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response.data.errors);
            });
        });        
    },
    getUserKankolekQR(context) {
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/get-kankolek-qr`, {
                "cognitoSub"        : state.businessDetails?.cogUserSub??null,
                "businessId"        : state.businessDetails?.businessId??null,
                "businessName"      : state.businessDetails?.businessName??null,
                "businessAddress"   : state.businessDetails?.businessAddress??null
            })
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    context.commit('UPDATE_BUSINESS_QR_INFO', data.message);
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response.data.errors);
            });
        });        
    },
    updateWatchlistStatus(context, params) {
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/update-watchlist-status`, params)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    resolve(data.message);
                }else{
                    reject(data);
                }
            })
            .catch(({ response }) => {
                reject(response.data);
            });
        });        
    },
    updateStoreCategory(context, params) {
        return new Promise((resolve, reject) => {
            API2.post(`/merchant/update-store-category`, params)
            .then(({ data }) => {
                if((data?.status ?? "err") =="ok"){
                    context.commit('UPDATE_STORE_CATEGORY', params?.storeCategory);
                    resolve(data.message);
                }else{
                    reject(data.message);
                }
            })
            .catch(({ response }) => {
                reject(response.data);
            });
        });        
    },
}

export const getters = {
    
}